module.exports = __webpack_public_path__ + "static/img/icon-head.1776169966151.png";